// extracted by mini-css-extract-plugin
export default {"loading":"ocVyr","product":"Hu7rf"};